import { Progress } from "@/components/ui/progress";

interface PackingProgressBarProps {
  packedCount: number;
  totalCount: number;
}

export function PackingProgressBar({ packedCount, totalCount }: PackingProgressBarProps) {
  const percentage = totalCount > 0 ? Math.round((packedCount / totalCount) * 100) : 0;
  
  const getProgressColor = () => {
    if (percentage < 30) return "bg-destructive";
    if (percentage < 70) return "bg-yellow-500";
    return "bg-green-500";
  };

  const getStatusIcon = () => {
    if (percentage === 100) return "✅";
    return "🔄";
  };

  const getStatusText = () => {
    if (percentage === 100) return `Packed: ${packedCount} of ${totalCount}`;
    return `Packing: ${packedCount} of ${totalCount} Items`;
  };

  return (
    <div className="w-full">
      <div className="flex items-center justify-between gap-2 mb-2">
        <span className="text-xs sm:text-sm font-medium text-muted-foreground flex items-center gap-1">
          <span className="text-base">{getStatusIcon()}</span>
          <span className="hidden sm:inline">{getStatusText()}</span>
          <span className="sm:hidden">{packedCount}/{totalCount}</span>
        </span>
        <span className="text-xs font-bold text-primary">
          {percentage}%
        </span>
      </div>
      
      <div className="w-full">
        <div className="h-2 sm:h-1 bg-white/10 rounded-full overflow-hidden">
          <div 
            className={`h-full transition-all duration-500 rounded-full ${getProgressColor()}`}
            style={{ width: `${percentage}%` }}
          />
        </div>
      </div>
    </div>
  );
}